<script setup lang="ts">
import { useSiteStore } from '@/stores/site'
import AppMenuItem from './AppMenuItem.vue'
import { computed } from 'vue'
import FairChoicer from '@/components/FairChoicer.vue'

const siteStore = useSiteStore()

const menuItems = computed(() => siteStore.menuItems)
</script>

<template>
  <div>
    <FairChoicer class="lg:hidden" />
    <ul class="layout-menu">
      <template v-for="(item, i) in menuItems" :key="item">
        <AppMenuItem :item="item" :index="i"></AppMenuItem>
      </template>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.menu-separator {
  border-bottom: 1px solid var(--surface-border);
}
</style>
